import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";

const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const AdminReview = lazy(() => import("./pages/AdminReview.tsx"));
const FootballQuizLanding = lazy(() => import("./pages/FootballQuizLanding.tsx"));
const PremierLeagueQuizPage = lazy(() => import("./pages/PremierLeagueQuizPage.tsx"));
const HardFootballQuizPage = lazy(() => import("./pages/HardFootballQuizPage.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/football-quiz" element={<FootballQuizLanding />} />
            <Route path="/premier-league-quiz" element={<PremierLeagueQuizPage />} />
            <Route path="/hard-football-quiz" element={<HardFootballQuizPage />} />
            <Route path="/admin/review" element={<AdminReview />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
